/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import {
  UPDATE_PROMOCODES,
} from '../../constants/actionType'

/**
 * Declare Variable
 */
const updatePromocodesAction = createAction(UPDATE_PROMOCODES)

/**
 * Export
 */
export const updatePromocodes = (value) => async (dispatch) => {
  try {
    dispatch(updatePromocodesAction(value))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/components/promocodes.js